import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AnalogyLogo from "@/components/AnalogyLogo";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) { toast.error("At least 8 characters please."); return; }
    if (pwd !== pwd2) { toast.error("Passwords don't match."); return; }
    setSaving(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
      setTimeout(() => nav("/login"), 1800);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] p-4" data-testid="reset-password-page">
      <div className="w-full max-w-sm bg-white card-flat p-8">
        <AnalogyLogo size={26} className="text-slate-900 mb-6" />

        {!done ? (
          <>
            <div className="label-overline mb-3">Reset password</div>
            <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900">Set a new password</h1>
            <p className="text-slate-500 text-sm mt-2">This link works once and expires 30 minutes after it was sent.</p>

            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="rp-pwd" className="label-overline">New password</Label>
                <Input id="rp-pwd" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)}
                  placeholder="At least 8 characters" className="mt-2 rounded-sm" autoFocus data-testid="reset-password-new" required />
              </div>
              <div>
                <Label htmlFor="rp-pwd2" className="label-overline">Confirm new password</Label>
                <Input id="rp-pwd2" type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)}
                  className="mt-2 rounded-sm" data-testid="reset-password-confirm" required />
              </div>
              <Button type="submit" disabled={saving} className="w-full rounded-sm bg-[#F54800] hover:bg-[#D63E00] text-white" data-testid="reset-password-submit">
                {saving ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : null}
                {saving ? "Saving…" : "Set new password"}
              </Button>
            </form>
            <Link to="/forgot-password" className="mt-4 block text-xs text-slate-500 hover:text-[#F54800] hover:underline text-center" data-testid="reset-password-request-new-link">
              Link expired or not working? Request a new one
            </Link>
          </>
        ) : (
          <div className="py-4 text-center" data-testid="reset-password-done">
            <CheckCircle2 size={32} className="mx-auto mb-3 text-green-600" />
            <h1 className="font-display text-xl font-bold text-slate-900">Password updated</h1>
            <p className="text-sm text-slate-600 mt-3">Taking you to sign in…</p>
          </div>
        )}
      </div>
    </div>
  );
}
